<template>
  <div class="p-menu-plan-block" :class="{ 'active': isUse }">
    <img src="@/assets/images/menu/plan_balloon.png" v-if="isUse">
    <div
        class="p-menu-plan-block__outside"
        :class="{
        'p-menu-plan-block--recommend': recommend,
        'active' : isUse
      }"
    >
      <div v-if="plan.planBasicInfo" class="p-menu-plan-block__inner">
        <div
            class="p-menu-plan-block__contents"
            :class="{ 'p-menu-plan-block__contents--wide': !plan.planBasicInfo.planImages }"
        >
          <p class="p-menu-plan-block__title">{{ plan.planBasicInfo.planNm }}</p>
          <ul
              v-if="plan.planType === 3"
              class="p-menu-plan-block__status p-menu-plan-block__status--gourmet"
          >
            <li v-for="item in plan.gourmetStatus" :key="item.id">
              <Icon :name="iconType(item.type)"/>
              {{ item.label }}
            </li>
          </ul>
          <ul
              class="p-menu-plan-block__status p-menu-plan-block__status--benefit"
          >
            <li v-for="item in getPlanIcon" :key="item.iconCd"
                :class="{'active' : item.iconCd == 'kyu_toku_barai'}">
              {{ item.iconNm }}
            </li>
          </ul>

          <ul class="schedule_list">
            <li>
              <p>取扱公演期間</p>
              <span>{{plan.ticketPerfHeading.performanceTerm}}</span>
            </li>
            <li class="place">
              <p>開催場所</p>
              <span>{{plan.ticketPerfHeading.venue}}</span>
            </li>
            <li>
              <p class="sale">チケット販売期間</p>
              <span>{{plan.ticketPerfHeading.saleTerm}}</span>
            </li>
          </ul>

          <div class="bottom_area">
            <div class="gray_area" :class="{'active' : isUse}">
              <div class="right_box">
                <p class="title">チケット料金一例</p>
                <dl>
                  <dt>{{seatType}}</dt>
                  <dd>{{ getPayType }}： {{ getFee }}円</dd>
                </dl>
              </div>
              <div class="left_box">
                <p class="title">特典</p>
                <dl>
                  <dt>{{plan.ticketInfo.perfBenefitContent}}</dt>
                  <dd v-if="showBenepoValue">ベネポ{{ showBenepoValue.value }}{{ showBenepoValue.prefix }}付与</dd>
                </dl>
              </div>
            </div>

            <div
                class="c-buttonWrap5"
                @click="
              $router.push(
                `/menus/catExl=${queryCode.catExl}/catLrg=${queryCode.catLrg}/catMid=${queryCode.catMid}/catSml=${queryCode.catSml}/menuNo=${queryCode.menuNo}/plans/planId=${plan.planBasicInfo.planId}`
              )
            "
            >
              <Button style-type="secondary" color="color2">
                詳細を見る
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuNo: {
      required: true,
    },
    recommend: {
      default: 0,
    },
    plan: {
      type: Object,
      default: () => ({}),
    },
    iconCd: {
      required: true,
    },
    recommendationPlanData: {
      type: Object,
      default: () => ({}),
    },
    seatType: {
      type: String,
      default: () => (''),
    }
  },
  data() {
    return {};
  },
  computed: {
    /**
     * 価格の種類を取得する
     */
    getPayType() {
      if (this.recommendationPlanData.pyrlDedPayeeDiv == "1") {
        // 1:給トクのみ
        return "給トク価格";
      } else if (this.recommendationPlanData.pyrlDedPayeeDiv == "2") {
        // 2:給トク以外
        return "会員価格";
      }
      return "会員価格";
    },
    /**
     * 価格を取得する
     */
    getFee() {
      // let price = 0;
      // if (this.recommendationPlanData.pyrlDedPayeeDiv == "1") {
      //   // 1:給トクのみ
      //   price = this.recommendationPlanData.pyrlDedDiscount;
      // } else if (this.recommendationPlanData.pyrlDedPayeeDiv == "2") {
      //   // 2:給トク以外
      //   price = this.recommendationPlanData.price;
      // } else {
      //   price = this.recommendationPlanData.price;
      // }

      return this.recommendationPlanData.price;
    },
    showBenepoValue() {
      if (
        !this.recommendationPlanData ||
        !this.recommendationPlanData.benepoReturnInfo ||
        !this.recommendationPlanData.benepoReturnInfo.benepoReturnDiv
      )
        return null;
      if (
        this.recommendationPlanData.benepoReturnInfo.benepoReturnDiv == "10"
      ) {
        return {
          value: this.recommendationPlanData.benepoReturnInfo.benepoReturnRate,
          prefix: "%"
        };
      } else if (
        this.recommendationPlanData.benepoReturnInfo.benepoReturnDiv == "20"
      ) {
        return {
          value: this.recommendationPlanData.benepoReturnInfo.benepoReturnFixed,
          prefix: "ポイント"
        };
      } else {
        return null;
      }
    },
    // 取得したイメージオブジェクトが配列かどうかチェック
    isPlanImagesArray() {
      const objectType = Object.prototype.toString;
      return objectType.call(this.plan.planBasicInfo.planImages) == '[object Array]';
    },
    isUse() {
      return this.iconCd == 'kyu_toku_barai' ? true : false;
    },
    queryCode() {
      return {
        catExl: this.$route.params.catExl
            ? this.$route.params.catExl.replace("catExl=", "")
            : "",
        catLrg: this.$route.params.catLrg
            ? this.$route.params.catLrg.replace("catLrg=", "")
            : "",
        catMid: this.$route.params.catMid
            ? this.$route.params.catMid.replace("catMid=", "")
            : "",
        catSml: this.$route.params.catSml
            ? this.$route.params.catSml.replace("catSml=", "")
            : "",
        menuNo: this.$route.params.menuNo
            ? this.$route.params.menuNo.replace("menuNo=", "")
            : "",
        planId: this.$route.params.planId
            ? this.$route.params.planId.replace("planId=", "")
            : "",
      };
    },
    getPlanIcon() {
      let result =  this.plan?.planIcons?.length > 0 ? _.cloneDeep(this.plan?.planIcons) : [];
      return result;
    }
  },
  methods: {
    iconType(type) {
      let iconName = "status_";
      switch (type) {
        case 1:
          iconName += "morning";
          break;
        case 2:
          iconName += "lunch";
          break;
        case 3:
          iconName += "teatime";
          break;
        case 4:
          iconName += "dinner";
          break;
      }
      return iconName;
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
